<template>
  <div class="sinoa-streaming-status pa-3 rounded">
    <div class="d-flex align-center">
      <v-icon
        size="12"
        color="grey"
        class="mr-1 flex-shrink-0"
      >
        mdi-information-outline
      </v-icon>
      <span class="text-caption grey--text">
        Feel free to close Sinoa — just stay on this page to receive the response
      </span>
      <span class="text-caption grey--text text--lighten-1 ml-auto flex-shrink-0">{{ elapsedFormatted }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'SinoaStreamingStatus',

  data() {
    return {
      elapsedSeconds: 0,
      elapsedInterval: null,
    };
  },

  computed: {
    ...mapGetters('chatbot', ['isStreaming']),
    ...mapState('chatbot', ['streamingStartedAt']),

    elapsedFormatted() {
      const mins = Math.floor(this.elapsedSeconds / 60);
      const secs = this.elapsedSeconds % 60;
      return `${mins}:${String(secs).padStart(2, '0')}`;
    },
  },

  watch: {
    isStreaming(val) {
      if (val) {
        this.startInterval();
      } else {
        this.stopInterval();
      }
    },
  },

  mounted() {
    if (this.isStreaming) {
      this.startInterval();
    }
  },

  beforeDestroy() {
    this.stopInterval();
  },

  methods: {
    startInterval() {
      this.stopInterval();
      this.elapsedSeconds = this.streamingStartedAt
        ? Math.floor((Date.now() - this.streamingStartedAt) / 1000)
        : 0;

      this.elapsedInterval = setInterval(() => {
        this.elapsedSeconds += 1;
      }, 1000);
    },

    stopInterval() {
      clearInterval(this.elapsedInterval);
      this.elapsedInterval = null;
    },
  },
};
</script>

<style scoped>
.sinoa-streaming-status {
  background: #f0f9fb;
  border-left: 3px solid #12A8C4;
}
</style>
